<template lang="html">
    <article class="user-auth">
        <div class="container-fluid">
            <div class="wrapper">
                <h1>Reset your password</h1>
                <vue-form v-if="!formState.$submitted || !errors.$clean" :state="formState" name="forgottenPasswordForm" @submit.prevent>
                    <validate class="form-group">
                        <field-messages class="invalid-feedback" name="password" show="$dirty && $invalid">
                            <div slot="required">Password is required</div>
                            <div slot="minlength">Password is too short</div>
                        </field-messages>
                        <input type="password" id="password" name="password" minlength="6" required class="form-control client-budget" v-model="password.first">
                        <label for="password">Password*</label>
                    </validate>
                    <validate class="form-group">
                        <field-messages class="invalid-feedback" name="confirmPassword" show="$dirty && $invalid">
                            <div slot="required">Confirm password is required</div>
                            <div slot="matches">Password does not match</div>
                        </field-messages>
                        <input type="password" id="confirmPassword" name="confirmPassword" :matches="password.first" required class="form-control client-budget" v-model="password.second">
                        <label for="confirmPassword">Confirm Password*</label>
                    </validate>
                    <section class="form-footer">
                        <button class="btn btn-primary btn-login" @click="resetPassword" type="submit" :disabled="formState.$invalid">Reset</button>
                        <div class="btn-wrapper">
                            <router-link to="/login">Back to login</router-link>
                        </div>
                    </section>
                </vue-form>
                <div v-else>
                    <router-link to="/login">Login</router-link>
                </div>
                <result-message :success="success" :errors="errors"></result-message>
            </div>
        </div>
    </article>

</template>

<script>
    import { mapGetters } from 'vuex';
    import userServices from '../services/users';
    import ResultMessage from '../helpers/ResultMessage';

    export default {
        name: 'resetPassword',
        components: {
            ResultMessage
        },
        data () {
            return {
                formState: {},
                success: {
                    show: false,
                    message: 'Success'
                },
                errors: {
                    type: Object|Error,
                    $clean: true
                },
                password: {},
            }
        },
        computed: {
            ...mapGetters(['isLoggedIn']),
        },
        methods: {
            resetPassword() {
                userServices.resetPassword(this.$route.params.token, this.password ).then(user => {
                    let self = this;
                    self.success.show = true;
                    setTimeout(function(){
                        self.success.show = false;
                    }, 800);
                }).catch((errors) => {
                    this.errors.$clean = false;
                    this.errors = errors;
                    console.log(this.errors)

                });
            }
        }
    }
</script>

<style lang="css">
</style>
